import { HttpStatusCodeEnum } from '../../@core/@shared/domain/enums/HttpStatusCode.enum'
import { DashboardAgilityClient } from './DashboardAgility.client'
import { SmartProcessingDataApiSchema } from './DashboardAgility.schemas'
import { SmartProcessingData } from './DashboardAgility.types'

export class DashboardAgilityRepository {
	private _endpoint = 'v2/DashboardAgility/recuperar-dados-processamento-smart-por-id-fazenda'

	constructor(private _httpClient: DashboardAgilityClient) {}

	async getSmartProcessingDataByFarmId(farmId: string): Promise<SmartProcessingData> {
		const response = await this._httpClient.get(this._endpoint, {
			params: { idFazenda: farmId },
		})

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error(
				'Não foi possível recuperar os dados de processamento smart. Por favor, tente novamente',
			)
		}

		return SmartProcessingDataApiSchema.parse(response.data)
	}
}
